module.exports = __webpack_public_path__ + "static/img/banner.d521b62.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/home/download/banner.png
// module id = LeqV
// module chunks = 3